export const BORDER_RADIUS = '10px';
